import { computed, Ref } from 'vue';
import { format, formatISO, getDate, getMonth, getYear, isExists, parseISO } from 'date-fns';
import { B2CMyBoliaProfileModel } from '@/b2c/shared/api/server-apis';
import profileStore from '@/b2c/profile/profile.store';

export default function useBirthday() {
    const profile: Ref<B2CMyBoliaProfileModel> = computed(() => profileStore.profile);

    const birthdayAsDate = (day: string | null, month: string | null, year: string | null): string => {
        const birthdayHasValues = !!year && !!month && !!day;
        if (!birthdayHasValues) {
            return '';
        }
        const date = { year: parseInt(year, 10), month: parseInt(month, 10) - 1, day: parseInt(day, 10) };

        const isValidDate = isExists(date.year, date.month, date.day);
        if (!isValidDate) {
            return '';
        }

        return formatISO(new Date(date.year, date.month, date.day));
    };

    const birthdayDateAsObject = computed(() => {
        if (!profile.value.birthday) return { day: null, month: null, year: null };

        return {
            day: getDate(parseISO(profile.value.birthday.toString())).toString(),
            month: (getMonth(parseISO(profile.value.birthday.toString())) + 1).toString(),
            year: getYear(parseISO(profile.value.birthday.toString())).toString(),
        };
    });

    const birthdayDateAsFormattedString = computed(() => {
        if (profile.value.birthday) {
            return format(parseISO(profile.value.birthday.toString()), 'dd/MM/yyyy');
        }
        return '-';
    });

    return {
        birthdayAsDate,
        birthdayDateAsObject,
        birthdayDateAsFormattedString,
    };
}
